import isEmpty from 'lodash/isEmpty'
import { ROUTES, USER_ROLES } from '../constants'
import { CROPMASTER_USER_ROLES } from '@layers-frontend/commons/constants'
import { hasRoleDeactivateDashboard } from '@layers-frontend/commons/store/selectors/user'
import { canUseLayi, getBiLabsUrl, hasUserRole } from './users'

// Landing page after login, by role. A ROLE_HOME_<PAGE> role only says where to land: the page's own
// access rule (`canSee`: the one that shows its top-bar icon, or the page's own redirect) still decides
// whether the user gets there, so a home role without access is inert and the viewer stays the landing
// page — checked here rather than by the page's own redirect, so the login never chains two redirects
// (Crop Master sends a user without access back to `/`: it would loop). Ordered: the first match wins.
const HOME_PAGES = [
  { role: USER_ROLES.ROLE_HOME_LAYI, route: ROUTES.CHAT_ROUTE, canSee: canUseLayi },
  { role: USER_ROLES.ROLE_HOME_DASHBOARD, route: ROUTES.DASHBOARD_ROUTE, canSee: state => !hasRoleDeactivateDashboard(state) },
  { role: USER_ROLES.ROLE_HOME_BILABS, route: ROUTES.BILABS_ROUTE, canSee: state => !isEmpty(getBiLabsUrl(state)) },
  { role: USER_ROLES.ROLE_HOME_CROP_MASTER, route: ROUTES.CROP_MASTER_ROUTE, canSee: state => hasUserRole(state, CROPMASTER_USER_ROLES.ROLE_CROP_MASTER) }
]

export const getHomeRoute = state => {
  const home = HOME_PAGES.find(page => hasUserRole(state, page.role) && page.canSee(state))
  return home ? home.route : ROUTES.LAYERS_ROUTE
}
